import api from '../services/api';
import { ISchedule } from '../shared/interfaces';

export interface IPublicScheduleRequestPayload {
  patient_name: string;
  cpf_cnpj: string;
  birthday: string;
  cell_phone: string;
  email?: string;
  professional_id: string;
  date: string;
  start_time: string;
  end_time: string;
  observation?: string;
}

export interface IPublicAvailabilityInterval {
  id: string;
  title: string;
  start: string;
  end: string;
  confirmation_status?: string;
}

export interface IPublicAvailabilityResponse {
  professional: {
    id: string;
    name: string;
  };
  date: string;
  busy_intervals: IPublicAvailabilityInterval[];
}

export const getSchedules = async (
  start: string,
  end: string,
  professional_id: string | null,
): Promise<ISchedule[]> => {
  const response = await api.post('/schedules/list', {
    start,
    end,
    professional_id,
  });
  return response.data;
};

export const postSchedule = async (payload: any): Promise<ISchedule> => {
  const response = await api.post('/schedules', payload);
  return response.data;
};

export const postPublicScheduleRequest = async (
  payload: IPublicScheduleRequestPayload,
) => {
  const response = await api.post('/schedules/public/request', payload);
  return response.data;
};

export const getPublicScheduleAvailability = async (payload: {
  professional_id: string;
  date: string;
}): Promise<IPublicAvailabilityResponse> => {
  const response = await api.post('/schedules/public/availability', payload);
  return response.data;
};

export const patchSchedule = async (
  id: string | undefined,
  payload: any,
): Promise<ISchedule> => {
  if (!id) {
    throw new Error('ID do agendamento não fornecido.');
  }
  const response = await api.patch(`/schedules/${id}`, payload);
  return response.data;
};

export const getScheduleConfirmToken = async (
  scheduleId: string,
  token: string,
) => {
  const response = await api.get(
    `/schedules/confirm/${scheduleId}?token=${token}`,
  );
  return response.data;
};

export const postScheduleConfirmation = async (
  scheduleId: string,
  payload: {
    token: string;
    status: 'confirmed' | 'cancelled';
    notes?: string;
  },
) => {
  const response = await api.post(`/schedules/confirm/${scheduleId}`, payload);
  return response.data;
};

export const generateScheduleConfirmToken = async (scheduleId: string) => {
  const response = await api.post(`/schedules/${scheduleId}/generate-token`);
  return response.data;
};

export const sendScheduleConfirmationEmail = async (payload: {
  schedule_id: string;
  email: string;
  token: string;
}) => {
  const response = await api.post(
    '/schedules/send-confirmation-email',
    payload,
  );
  return response.data;
};

export const sendScheduleConfirmationWhatsapp = async (payload: {
  schedule_id: string;
  phone: string;
  link: string;
  client_name?: string;
}) => {
  const response = await api.post(
    '/schedules/send-confirmation-whatsapp',
    payload,
  );
  return response.data;
};
